import ReactGA from "react-ga4";

declare global {
  function rdt(action: string, ...args: any[]): void;
  function fbq(action: string, ...args: any[]): void;
}

export function trackEvent(event: string) {
  ReactGA.event(event);
  if (!import.meta.env.DEV) {
    rdt("track", "Custom", { customEventName: event });
    fbq("trackCustom", event);
  }
}

export function trackRedditEvent(event: string) {
  if (!import.meta.env.DEV) {
    rdt("track", "Custom", { customEventName: event });
  }
}
